type RowObj = {
	name: string;
	status: string;
	date: string;
	progress: number;
};

const tableDataComplex: RowObj[] = [
	{
		name: 'Lorem Ipsum dot amet',
		progress: 75.5,
		status: 'Aprovado',
		date: '12 Jan 2021'
	},
	{
		name: 'Lorem Ipsum dot amet',
		progress: 25.5,
		status: 'Finalizado',
		date: '21 Feb 2021'
	},
	{
		name: 'Lorem Ipsum dot amet',
		progress: 90,
		status: 'Erro',
		date: '13 Mar 2021'
	},
	{
		name: 'Lorem Ipsum dot amet',
		progress: 50.5,
		status: 'Aprovado',
		date: '24 Oct 2022'
	}
];
export default tableDataComplex;
